import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { CreditCard, Calendar, Download } from 'lucide-react';

export default function InvoicesPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('invoices')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  const getStatusColor = (status) => {
    switch(status) {
      case 'payée': return 'bg-green-500/20 text-green-400';
      case 'en_attente': return 'bg-yellow-500/20 text-yellow-400';
      case 'impayée': return 'bg-red-500/20 text-red-400';
      default: return 'bg-gray-500/20 text-gray-400';
    }
  };

  const totalAmount = data.reduce((sum, inv) => sum + (inv.amount || 0), 0);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-cyan-400 flex items-center gap-2">
          <CreditCard size={24} />
          Factures ({data.length})
        </h2>
        <div className="bg-gray-900 px-4 py-2 rounded-lg border border-gray-800">
          <span className="text-gray-400">Total: </span>
          <span className="text-green-400 font-bold">{totalAmount.toLocaleString()} €</span>
        </div>
      </div>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-gray-800 text-gray-300">
              <tr>
                <th className="p-3">N° Facture</th>
                <th className="p-3">Client</th>
                <th className="p-3">Montant</th>
                <th className="p-3">Statut</th>
                <th className="p-3">Date échéance</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {data.map(invoice => (
                <tr key={invoice.id} className="hover:bg-gray-800/50">
                  <td className="p-3 text-white font-mono">{invoice.invoice_number}</td>
                  <td className="p-3 text-gray-300">{invoice.client_name}</td>
                  <td className="p-3 text-green-400 font-bold">{invoice.amount?.toLocaleString()} €</td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded-full text-xs ${getStatusColor(invoice.status)}`}>
                      {invoice.status}
                    </span>
                  </td>
                  <td className="p-3 text-gray-300 flex items-center gap-1">
                    <Calendar size={14} />
                    {new Date(invoice.due_date).toLocaleDateString()}
                  </td>
                  <td className="p-3">
                    <button className="text-cyan-400 hover:text-cyan-300">
                      <Download size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
